module.exports = __webpack_public_path__ + "bed-button-rule.5ca7263a.png";